/**
 * @file 応募のLINE設定
 *
 */

 
/**
 * @classname LineSettings
 * @classdesc LINE設定
 */
export default class LineSettings {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('LineSettings.constructor');
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};
 
	/**
	 * click
	 *
	 * @memberof LineSettings
	 * @return {undefined}
	 */
	onClick() {
		console.log('LineSettings.onClick');
		let url = 'https://line.me/R/oaMessage/%40791blvcz/?';
		const staff_name = $('#staff_name').val()
		const staff_id = $('#staff_id').val()
		const job_no = $('#job_no').text()
		let office_name = $('#facility_name').text()
		const occupation = $('#occupation').val()
		let text = '';
		if ($('body').hasClass('page-my')) {
			text =
`【スタッフ名】${staff_name} 様
【スタッフNo】107135329341
【仕事番号】${job_no}
【勤務先名】${office_name}
【職種】${occupation}
【お問い合わせ、ご予約内容】
※求人説明をご希望の場合は、こちらのフリースペースに①勤務先名　②希望の日時を記載ください。

フリーダイヤル：
0120-263-625
営業時間
月～金　9:30～19:00
祝・土　9:30～18:00
※日曜　定休

【その他お問い合わせ内容】
※複数の求人説明をご希望の場合は、こちらのフリースペースに勤務先名を記載ください。`
		} else {
			text =
`【スタッフ名】${staff_name} 様
【スタッフNo】${staff_id}
【仕事番号】${job_no}
【勤務先名】${office_name}
【職種】${occupation}
【お電話可能な日時】
候補①
候補②
候補③

フリーダイヤル：
0120-353-161
営業時間
月～金　9:30～19:00
祝・土　9:30～18:00
※日曜　定休

【その他お問い合わせ内容】
※複数の求人説明をご希望の場合は、こちらのフリースペースに勤務先名を記載ください。`
		}

		text = encodeURIComponent(text)
		url += text
		location.href = url
	}
}

